<div class="main">
  <div id="tabledata">
    <p-table #dt [value]="currResultData" [columns]="currColumns" [tableStyle]="{ 'min-width': '50rem' }" showGridlines
      [loading]="loading" [rows]="15" [lazy]="true" (onLazyLoad)="loadRecordsLazy($event)" [sortField]="sortField"
      [sortOrder]="sortOrder" [filterDelay]="500" [totalRecords]="currResultTotal" paginator="true"
      [rowsPerPageOptions]="[15, 30, 50, 150]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th *ngIf="col.isDisplay" [pSortableColumn]="
                col.field !== 'S_NO' && col.field !== 'productPackageImage'
                  ? col.field
                  : null
              " [ngStyle]="
                col.field === 'S_NO'
                  ? {
                      'text-align': 'center',
                      color: '#fff',
                      'background-color': '#236277'
                    }
                  : {
                      color: '#fff',
                      'background-color': '#236277'
                    }
              ">
              <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                ">
                <span style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                  ">
                  {{ col.header }}
                  <p-sortIcon *ngIf="
                      col.field !== 'S_NO' &&
                      col.field !== 'productPackageImage'
                    " [field]="col.field"></p-sortIcon>
                </span>
                <!-- <p-columnFilter
                  *ngIf="
                    col.field !== 'S_NO' &&
                    col.field !== 'productPackageImage'
                  "
                  type="text"
                  [field]="col.field"
                  display="menu"
                  class="ml-auto"
                ></p-columnFilter> -->
              </div>
            </th>
          </ng-container>
        </tr>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th *ngIf="col.isDisplay" [ngStyle]="{
                'text-align': col.field === 'S_NO' ? 'center' : null,
                'min-width': col.columnWidth + 'px',
                'max-width': col.columnWidth + 'px',
                padding: '10px 6px ',
                color: '#fff',
                'background-color': '#236277'
              }">
              <p-columnFilter *ngIf="
                  col.field !== 'S_NO' && col.field !== 'productPackageImage'
                " [field]="col.field" class="ml-auto custom-filter-input" placeholder="Search by {{ col.header }}"
                [matchMode]="'contains'"></p-columnFilter>
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.isDisplay" [ngStyle]="
                col.field === 'S_NO'
                  ? {
                      'text-align': 'center',
                      padding: '0px',
                      'min-width': col.columnWidth + 'px',
                      'max-width': col.columnWidth + 'px',
                      'word-break': 'break-all'
                    }
                  : {
                      padding: '0 0 0 6px',
                      'min-width': col.columnWidth + 'px',
                      'max-width': col.columnWidth + 'px',
                      'word-break': 'break-all'
                    }
              ">
              <div class="tableDataColumn" [ngStyle]="
                  col.field === 'S_NO' ? { 'text-align': 'center' } : {}
                ">
                <!-- For text -->
                <span *ngIf="
                    col.field !== 'country' &&
                    col.field !== 'productPackageImage'
                  ">
                  <!-- For gapd_mongos table columns -->
                  @if (col.field !== 'chemicalStructure' && col.field !==
                  'iupac' && col.field !== 'casRn' && col.field !==
                  'chemicalClass' && col.field !== 'mechanismOfActionMoa' &&
                  col.field !== 'indication') {
                  <!-- For normal text -->
                  <p class="data" *ngIf="col.field !== 'documents'" style="padding-right: 8px">
                    {{ rowData[col.field] }}
                  </p>

                  <!-- For document link -->
                  <p class="data" *ngIf="col.field === 'documents'">
                    <ng-container *ngFor="let file of getDocumentList(rowData)">
                      <button style="
                          border: none;
                          background-color: #236277;
                          border-radius: 6px;
                          padding: 5px 8px;
                          font-size: 14px;
                        ">
                        <a [href]="
                            'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' +
                            file
                          " target="_blank" style="text-decoration: none; color: #fff">
                          {{
                          file.length < 15 ? file : (file | slice : 0 : 15) + "..." }} </a>
                      </button>
                      <br />
                    </ng-container>
                  </p>
                  }

                  <!-- For basic_product_detail_MONGO columns  -->
                  @if (col.field === 'chemicalStructure' || col.field ===
                  'iupac' || col.field === 'casRn' || col.field ===
                  'chemicalClass' || col.field === 'mechanismOfActionMoa' ||
                  col.field === 'indication') {
                  <div style="max-height: 150px; overflow-y: auto" *ngIf="col.field !== 'chemicalStructure'">
                    <ul style="padding-left: 1.2rem">
                      @for (gbrnObj of rowData.gbrn_products; track $index) {
                      <li *ngIf="gbrnObj[col.field]" style="padding-right: 8px">
                        {{ gbrnObj[col.field] }}
                      </li>
                      }
                    </ul>
                  </div>
                  <div style="
                      max-height: 150px;
                      overflow-y: auto;
                      text-align: center;
                    " *ngIf="col.field === 'chemicalStructure'">
                    @for (gbrnObj of rowData.gbrn_products; track $index) {
                    <img style="height: 140px; width: 140px; object-fit: contain" [src]="
                        'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
                        gbrnObj[col.field]
                      " alt="Chemical structure" />
                    }
                  </div>
                  }
                </span>

                <!-- For images -->
                <span *ngIf="
                    col.field === 'country' ||
                    col.field === 'productPackageImage'
                  " style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  ">
                  <img [src]="
                      'https://www.chemrobotics.com/agropat/images/flag/' +
                      rowData[col.field] +
                      '.png'
                    " height="120" width="150" style="object-fit: contain" alt="Country"
                    *ngIf="col.field === 'country'" />
                  <img [src]="
                      rowData[col.field]
                        ? 'https://www.chemrobotics.com/agropat/images/agro_pro_dir/product_image1/' +
                          rowData[col.field]
                        : 'https://www.chemrobotics.com/assets/images/GAPD-Default-Image.png'
                    " alt="Company" height="120" width="150" style="object-fit: contain" alt="Company"
                    *ngIf="col.field === 'productPackageImage'" />
                </span>
              </div>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="main_leftScrollBtn" (click)="scrollLeft()">
    <i class="pi pi-angle-left"></i>
  </div>
  <div class="main_rightScrollBtn" (click)="scrollRight()">
    <i class="pi pi-angle-right"></i>
  </div>
</div>